<script>

import Option from './option'

export default {
    mixins: [Option]
}

</script>